import * as tslib_1 from "tslib";
import { Value } from '@swim/recon';
import { MapboxGeometryView } from './mapbox-geometry-view';
import { LngLat } from 'mapbox-gl';
var MapboxPointView = (function (_super) {
    tslib_1.__extends(MapboxPointView, _super);
    function MapboxPointView() {
        var _this = _super.call(this) || this;
        _this._feature = {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [],
            },
            properties: {
                id: _this._featureId,
            },
        };
        return _this;
    }
    Object.defineProperty(MapboxPointView.prototype, "center", {
        get: function () {
            var coordinates = this._feature.geometry.coordinates;
            if (coordinates.length === 2) {
                return new LngLat(coordinates[0], coordinates[1]);
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    MapboxPointView.prototype.coordinates = function (coordinates) {
        if (coordinates === undefined) {
            return this._feature.geometry.coordinates;
        }
        else {
            this._feature.geometry.coordinates = coordinates;
            return this;
        }
    };
    MapboxPointView.prototype.properties = function (properties) {
        if (properties === undefined) {
            return this._feature.properties;
        }
        else {
            if (this._feature.properties && properties) {
                for (var key in properties) {
                    var value = properties[key];
                    if (value) {
                        this._feature.properties[key] = value;
                    }
                }
            }
            else {
                this._feature.properties = properties;
            }
            return this;
        }
    };
    MapboxPointView.prototype.toGeoJson = function () {
        return this._feature;
    };
    MapboxPointView.prototype.didSetState = function (newState, oldState) {
        _super.prototype.didSetState.call(this, newState, oldState);
        var coordinates = newState.get('coordinates');
        if (coordinates.isDefined()) {
            var lng_1;
            var lat_1;
            coordinates.forEach(function (coord, index) {
                var key = coord.key.stringValue();
                if (key !== undefined) {
                    if (key === 'lng') {
                        lng_1 = coord.toValue().numberValue(lng_1);
                    }
                    else if (key === 'lat') {
                        lat_1 = coord.toValue().numberValue(lat_1);
                    }
                }
                else if (coord instanceof Value) {
                    if (index === 0) {
                        lng_1 = coord.numberValue(lng_1);
                    }
                    else if (index === 1) {
                        lat_1 = coord.numberValue(lat_1);
                    }
                }
            });
            if (lng_1 !== undefined && lat_1 !== undefined) {
                this.coordinates([lng_1, lat_1]);
            }
        }
        var properties = newState.get('properties');
        if (properties.isDefined()) {
            this.properties(properties.toAny());
        }
        this.requireRedraw();
    };
    return MapboxPointView;
}(MapboxGeometryView));
export { MapboxPointView };
//# sourceMappingURL=data:application/json;base64,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